export const CLASS_NAME = 'cst-chart-legend'
export const CHAR_WIDTH_PX = 5.25
export const LINE_HEIGHT_PX = 20
